module.exports = __webpack_public_path__ + "static/media/fiteconomy.bb381cfa.png";